<template>
	<div class="nav" v-if="!$route.meta.showHeader && isPc">
		<div class="nav_inner nav_mobile_bar" v-if="isMobileScreen">
			<el-image class="nav_logo pointer" :src="require('@/assets/logo.png')" fit="contain" @click="toIndex" />
			<div class="nav_mobile_btn" @click="mobileMenuOpen = !mobileMenuOpen">
				<span :class="{ open: mobileMenuOpen }"></span>
				<span :class="{ open: mobileMenuOpen }"></span>
				<span :class="{ open: mobileMenuOpen }"></span>
			</div>
		</div>
		<div class="nav_mobile_menu" v-if="isMobileScreen && mobileMenuOpen">
			<p class="nav_mobile_item" :class="{ active: defaultActive === '/p_index' }" @click="navTo('/p_index')">首页
			</p>
			<p class="nav_mobile_item" :class="{ active: defaultActive === '/p_retrieve' }"
				@click="navTo('/p_retrieve')">
				预约回收</p>
			<p class="nav_mobile_item" :class="{ active: defaultActive === '/p_new' }" @click="navTo('/p_new')">平台资讯</p>
			<p class="nav_mobile_item" :class="{ active: defaultActive === '/p_aboutUs' }" @click="navTo('/p_aboutUs')">
				关于我们</p>
		</div>
		<div class="nav_inner" v-show="!isMobileScreen">
			<el-menu :default-active="defaultActive" router class="nav_menu" mode="horizontal" :ellipsis="false">
				<el-image class="nav_logo pointer" :src="require('@/assets/logo.png')" fit="contain" alt="绿蜜蜂旧衣服回收首页"
					@click="toIndex" />
				<div class="nav_gap"></div>
				<el-menu-item index="/p_index">首页</el-menu-item>
				<el-menu-item index="/p_retrieve">预约回收</el-menu-item>
				<el-menu-item index="/p_new">平台资讯</el-menu-item>
				<el-menu-item index="/p_aboutUs">关于我们</el-menu-item>
				<div class="flex-grow" />
				<div class="nav_actions">
					<el-popover :width="220" popper-class="nav_qr_popover">
						<template #reference>
							<div class="nav_qr_btn">
								<el-image class="nav_qr_icon"
									src="https://lmf.lvmifo.com/static/upload/H5/7479101e8a1c06c8.png" fit="contain"
									alt="绿蜜蜂微信扫码入口" />
							</div>
						</template>
						<template #default>
							<div class="nav_qr_content">
								<p class="nav_qr_title">微信扫码</p>
								<el-image class="nav_qr_img" :src="require('@/assets/wxCode.png')" fit="contain"
									alt="绿蜜蜂微信公众号二维码" />
							</div>
						</template>
					</el-popover>
					<el-popover :width="220" popper-class="nav_qr_popover">
						<template #reference>
							<div class="nav_qr_btn">
								<el-image class="nav_qr_icon"
									src="https://lmf.lvmifo.com/static/upload/H5/a289b629ecd0ba5d.png" fit="contain"
									alt="绿蜜蜂支付宝扫码入口" />
							</div>
						</template>
						<template #default>
							<div class="nav_qr_content">
								<p class="nav_qr_title">支付宝扫码</p>
								<el-image class="nav_qr_img" :src="require('@/assets/zfbCode.png')" fit="contain"
									alt="绿蜜蜂支付宝生活号二维码" />
							</div>
						</template>
					</el-popover>
				</div>
			</el-menu>
		</div>
	</div>
	<div class="nav_placeholder" v-if="!$route.meta.showHeader && isPc"></div>

	<div style="width: 100vw;" :class="isPc ? 'minHeight' : ''">
		<router-view></router-view>
	</div>
	<div style="width: 100vw;" v-if="!$route.meta.showFooter && isPc">

		<!-- 企业资质 -->
		<div class="" style="background: #f8f8f8;">
			<div class="con_box flex footer_qualification">
				<div class="footer_qualification_left">
					<div class="">
						<h2 class="con_box_title">企业资质</h2>
					</div>
					<div style="margin-top: 40px;color: #666;">
						<div class="flex_y_center " style="margin-bottom: 24px;"
							v-for="(item, index) in qualificationList" :key="index">
							<el-image :src="item.img" fit="contain" :alt="item.title"
								style="width: 60px;height: 60px;margin-right: 24px;" />
							<p class="f20">{{ item.title }}</p>
						</div>
					</div>
				</div>
				<div class="footer_qualification_right">
					<div class="">
						<h2 class="con_box_title">联系我们</h2>
					</div>
					<div class=" " style="margin-top: 40px;color: #666;">
						<p class="f20 " style="margin-bottom: 16px;">客服电话</p>
						<p class="footer_contact_value">400-887-6885</p>
						<p class="f20 " style="margin-bottom: 16px;">合作邮箱</p>
						<p class="footer_contact_value footer_contact_email">lvmifo@163.com</p>
					</div>
				</div>
			</div>
		</div>
		<div style="background: #333;color: #fff;">
			<div class="con_box footer_bottom" style="padding: 20px 0;">
				<div class="flex_between center footer_bottom_inner">
					<el-image style="width: 120px;" class="pointer footer_bottom_logo"
						:src="require('@/assets/logo.png')" fit="contain" alt="绿蜜蜂旧衣服回收" @click="toIndex" />
					<div style="position: relative;top: 16px;">
						<div class="flex_y_center ">
							<p class="pointer" @click="toAboutUs">关于我们</p>
							<p style="width: 1px;height: 16px;background: #fff;margin: 0 20px;"></p>
							<p class="pointer" @click="telUs">加入我们</p>
							<p style="width: 1px;height: 16px;background: #fff;margin: 0 20px;"></p>
							<p class="pointer" @click="telUs">联系我们</p>
						</div>
						<p style="margin-top: 8px;" class="f12 c_gray">网站备案：沪ICP备19001740号-1</p>
					</div>

					<div class="flex_y_center flex_x_right" style="width: 160px;">
						<el-popover :width="220" popper-style="padding: 10px 0 0;">
							<template #reference>
								<div class="nav_qr_btn">
									<el-image class="nav_qr_icon"
										src="https://lmf.lvmifo.com/static/upload/H5/7479101e8a1c06c8.png" fit="contain"
										alt="绿蜜蜂微信扫码入口" />
								</div>
							</template>
							<template #default>
								<div class="center" style="">
									<el-image style="width: 200px;" :src="require('@/assets/wxCode.png')" fit="contain"
										alt="绿蜜蜂微信公众号二维码" />
								</div>
							</template>
						</el-popover>
						<div style="width: 30px;"></div>
						<el-popover :width="220" popper-style="padding: 10px 0 0;">
							<template #reference>
								<div class="nav_qr_btn">
									<el-image class="nav_qr_icon"
										src="https://lmf.lvmifo.com/static/upload/H5/a289b629ecd0ba5d.png" fit="contain"
										alt="绿蜜蜂支付宝扫码入口" />
								</div>
							</template>
							<template #default>
								<div class="center" style="">
									<el-image style="width: 200px;" :src="require('@/assets/zfbCode.png')" fit="contain"
										alt="绿蜜蜂支付宝生活号二维码" />
								</div>
							</template>
						</el-popover>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	markRaw
} from 'vue'
import {
	ElMessageBox
} from 'element-plus'
import {
	PhoneFilled
} from '@element-plus/icons-vue'
export default {
	name: 'App',
	components: {

	},
	data() {
		return {
			pageUrl: '',
			navList: [],
			headerList: [],
			openeds: [],
			isShowMenu: true,
			isLoading: false,
			path: '',
			isMobileScreen: false,
			mobileMenuOpen: false,
			qualificationList: [{
				img: require('@/assets/qualificationImage.png'),
				title: '中国再生资源回收利用协会会员单位'
			}, {
				img: require('@/assets/qualificationImage2.png'),
				title: '中国旧货业协会理事单位'
			}, {
				img: require('@/assets/qualificationImage3.png'),
				title: '江苏省循环经济协会会员单位'
			}, {
				img: require('@/assets/qualificationImage4.png'),
				title: '美团服务零售年度战略合作伙伴'
			}],
		}
	},
	computed: {
		isPc: function () {
			return !this.$route.path.startsWith('/m_')
		},
		defaultActive: function () {
			let path = this.$route.path
			if (path == '/p_newDetail') {
				path = '/p_new'
			}
			return path; //监听路由，控制菜单选择
		}
	},
	mounted() {
		this.updateScreenSize()
		window.addEventListener('resize', this.updateScreenSize)
		this.isiPhone()
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.updateScreenSize)
	},
	created() {
		let other_recycle_code = ''
		const isMobileLink = window.location.hash.indexOf('/m_') > -1
		console.log(window.location.href)

		if (sessionStorage.getItem('channelType')) {
			return false
		}

		// // 判断是否来源于顺丰小程序
		// if (window.location.href.indexOf('hostEnv=sfWxapp') > -1) {
		//   this.isPc = false
		//   sessionStorage.setItem('other_recycle_code', 126)
		//   sessionStorage.setItem('channelType', 'shunfeng')
		//   return false
		// }

		// 判断正常来源
		// if (window.location.href.indexOf('m_index') > -1 || window.location.href.indexOf('b_index') > -1) {
		if (window.location.href.indexOf('other_recycle_code') > -1) {
			let href = window.location.href.split('?')[1]
			for (let i in href.split('&')) {
				if (href.split('&')[i].indexOf('other_recycle_code') > -1) {
					sessionStorage.setItem('other_recycle_code', href.split('&')[i].split('=')[1])
					other_recycle_code = href.split('&')[i].split('=')[1]
				}
			}
		}
		// } else {
		//   other_recycle_code = sessionStorage.getItem('other_recycle_code')
		// }

		if (isMobileLink) {
			if (other_recycle_code == 121) {
				sessionStorage.setItem('channelType', 'debang')
			} else if (other_recycle_code == 126) {
				sessionStorage.setItem('channelType', 'shunfeng')
			} else if (other_recycle_code == 127) {
				sessionStorage.setItem('channelType', 'easy')
			} else if (other_recycle_code == 128) {
				sessionStorage.setItem('channelType', 'ruizhi')
			} else if (other_recycle_code == 129) {
				sessionStorage.setItem('channelType', 'sanjin')
			} else if (other_recycle_code == 130) {
				sessionStorage.setItem('channelType', 'jingdong')
			} else {
				sessionStorage.setItem('channelType', 'phone')
			}
		}

	},
	methods: {
		updateScreenSize() {
			this.isMobileScreen = window.innerWidth <= 768
			if (!this.isMobileScreen) {
				this.mobileMenuOpen = false
			}
		},
		navTo(path) {
			this.mobileMenuOpen = false
			this.$router.push(path)
		},
		telUs() {
			ElMessageBox.alert('400-887-6885', '服务热线', {
				confirmButtonText: '好的',
				type: 'success',
				icon: markRaw(PhoneFilled),
				callback: () => {

				},
			})
		},
		loginIn() {
			this.$router.push('/p_login')
		},
		toAboutUs() {
			this.$router.push('/p_aboutUs')
		},
		toIndex() {
			this.$router.replace('/')
		},

		isiPhone() {
			const screenHeight = window.screen.height;
			const innerHeight = window.innerHeight;
			// const bottomBarHeight = 40; // 假设底部横条的高度大约是40px
			console.log(screenHeight, innerHeight)
			if (screenHeight != innerHeight) {
				sessionStorage.setItem('isiPhoneBottom', 15)
			} else {
				sessionStorage.setItem('isiPhoneBottom', 0)
			}
		}
	}
}
</script>

<style scoped>
.minHeight {
	min-height: calc(100vh - 256px);
}

.nav {
	width: 100vw;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 100;
	background: rgba(255, 255, 255, 0.96);
	backdrop-filter: blur(12px);
	-webkit-backdrop-filter: blur(12px);
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 1px 12px rgba(0, 0, 0, 0.04);
}

.nav_inner {
	max-width: 1200px;
	margin: 0 auto;
	/* padding: 0 24px; */
	box-sizing: border-box;
}

.nav_placeholder {
	height: 64px;
}

.nav_menu {
	background: transparent !important;
	border-bottom: none !important;
	height: 64px;
	align-items: center;
}

.nav_logo {
	width: 120px;
	flex-shrink: 0;
}

.nav_gap {
	width: 48px;
	flex-shrink: 0;
}

.nav_actions {
	display: flex;
	align-items: center;
	gap: 16px;
	flex-shrink: 0;
}

.nav_qr_btn {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	/* background: rgba(245, 245, 245, 0.5); */
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.25s ease;
	border: 1px solid transparent;
}

.nav_qr_btn:hover {
	/* background: #fff; */
	border-color: #00a54f;
	box-shadow: 0 2px 8px rgba(0, 165, 79, 0.15);
	transform: translateY(-1px);
}

.nav_qr_icon {
	width: 28px;
	height: 28px;
	background: #fff;
	border-radius: 50%;
}

.nav_qr_content {
	text-align: center;
	padding: 8px 0 12px;
}

.nav_qr_title {
	font-size: 14px;
	color: #666;
	margin-bottom: 8px;
}

.nav_qr_img {
	width: 180px;
}

.nav_btn {
	height: 40px;
	border-radius: 40px;
	margin: 10px 0;
	padding: 0 25px;
	box-sizing: border-box;
	cursor: pointer;
}

.flex-grow {
	flex-grow: 1;
}

:deep(.nav_menu.el-menu--horizontal) {
	border-bottom: none;
}

:deep(.nav_menu.el-menu--horizontal > .el-menu-item) {
	height: 64px;
	line-height: 64px;
	font-size: 18px;
	color: #333;
	padding: 0 30px;
	margin: 0 4px;
	border-bottom: 2px solid transparent;
	transition: color 0.25s ease, border-color 0.25s ease;
	letter-spacing: 0.5px;
}

:deep(.nav_menu.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover) {
	background-color: transparent;
	color: #00a54f;
}

:deep(.nav_menu.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus) {
	background-color: transparent;
}

:deep(.nav_menu.el-menu--horizontal > .el-menu-item.is-active) {
	color: #00a54f !important;
	font-weight: 600;
	border-bottom-color: #00a54f;
	background-color: transparent !important;
}

.nav_mobile_bar {
	display: none;
	height: 56px;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	box-sizing: border-box;
}

.nav_mobile_btn {
	width: 40px;
	height: 40px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 5px;
	cursor: pointer;
}

.nav_mobile_btn span {
	display: block;
	width: 22px;
	height: 2px;
	background: #333;
	border-radius: 2px;
	transition: all .25s ease;
}

.nav_mobile_btn span.open:nth-child(1) {
	transform: translateY(7px) rotate(45deg);
}

.nav_mobile_btn span.open:nth-child(2) {
	opacity: 0;
}

.nav_mobile_btn span.open:nth-child(3) {
	transform: translateY(-7px) rotate(-45deg);
}

.nav_mobile_menu {
	position: fixed;
	top: 56px;
	left: 0;
	right: 0;
	z-index: 99;
	background: #fff;
	border-bottom: 1px solid #eee;
	box-shadow: 0 8px 20px rgba(0, 0, 0, .06);
	padding: 8px 0 12px;
}

.nav_mobile_item {
	padding: 14px 20px;
	font-size: 16px;
	color: #333;
}

.nav_mobile_item.active {
	color: #00a54f;
	font-weight: 600;
	background: rgba(0, 165, 79, .06);
}

.footer_qualification_left {
	width: 70%;
}

.footer_qualification_right {
	width: 30%;
}

.footer_contact_value {
	font-size: 32px;
	font-weight: bold;
	margin-bottom: 40px;
	word-break: break-all;
}

.footer_contact_email {
	margin-bottom: 0;
}

@media (max-width: 768px) {
	.nav_placeholder {
		height: 56px;
	}

	.nav_mobile_bar {
		display: flex;
	}

	.nav_inner:not(.nav_mobile_bar) {
		display: none;
	}

	.footer_qualification {
		flex-direction: column;
		gap: 32px;
	}

	.footer_qualification_left,
	.footer_qualification_right {
		width: 100%;
	}

	.footer_contact_value {
		font-size: 24px;
		margin-bottom: 24px;
	}

	.footer_bottom_inner {
		flex-direction: column;
		gap: 20px;
		align-items: center;
	}

	.footer_bottom_inner .footer_bottom_logo {
		display: none;
	}

	.footer_bottom_inner>div {
		position: static !important;
		top: auto !important;
		width: 100% !important;
		text-align: center;
	}

	.footer_bottom_inner .flex_y_center {
		justify-content: center;
		flex-wrap: wrap;
	}

	.minHeight {
		min-height: calc(100vh - 120px);
	}
}
</style>

<style>
.nav_qr_popover {
	padding: 0 !important;
	border-radius: 8px !important;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}
</style>